import { render } from "./EmphasisNotice.vue?vue&type=template&id=589ef8c2"
import script from "./EmphasisNotice.vue?vue&type=script&lang=js"
export * from "./EmphasisNotice.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./EmphasisNotice.vue?vue&type=style&index=0&id=589ef8c2&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__